import I18n from 'i18n-js';
import React from 'react';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { buttonClassName, RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { ArrowRightIcon } from '@reverbdotcom/cadence/icons/react';
import { MParticleEvent } from '@reverbdotcom/commons/src/elog/mparticle_types';

interface IProps {
  cspLink?: string;
  hideArrowIcon?: boolean;
  clickEvent?: MParticleEvent;
  similarListingsLink?: string;
}

export function SimilarListingsCTA(props: IProps) {
  const link = props.cspLink || props.similarListingsLink;

  return (
    <CoreLink
      to={link}
      clickEvent={props.clickEvent}
      className={buttonClassName({ variant: 'primary', fullWidth: true })}
    >
      {props.hideArrowIcon ?
        (
          I18n.t('discovery.item2EndedListingSearchButton.similarListingsCta')
        ) : (
          <RCTextWithIcon placement="right" svgComponent={ArrowRightIcon}>
            {I18n.t('discovery.item2EndedListingSearchButton.similarListingsCta')}
          </RCTextWithIcon>
        )}

    </CoreLink>
  );
}
